import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { makeStyles, useTheme } from '@mui/styles';
import { AppBar, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

// third-party
import clsx from 'clsx';

// project imports
import Breadcrumbs from '../ui-component/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
import navigation from '../menu-items';
import { drawerWidth } from '../store/constant';
import { SET_MENU } from '../store/actions';

// assets
import { IconChevronRight } from '@tabler/icons-react';

import FixedMenuLayout from './FixedMenuLayout';

// style constant
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    appBar: {
       backgroundColor: '#fff',
       color:theme.palette.background.secondaryLight
    },
    appBarWidth: {
        transition: theme.transitions.create('width'),
        backgroundColor: '#fff'
    },
    content: {
        ...theme.typography.mainContent,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            marginLeft: 5, //-(drawerWidth - 20),
            width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '5px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '5px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '5px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '5px',
            marginRight: '5px'
        }
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        // marginLeft: drawerWidth ,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        [theme.breakpoints.down('md')]: {
            marginLeft: '5px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '5px'
        }
    },
    footer: {
        marginBottom: '80px'
    },
    guest_footer: {
        marginTop: '88px !important',
        marginBottom: '20px'
    }
}));

//-----------------------|| MAIN LAYOUT ||-----------------------//

const MainLayout = ({ children }) => {
    const classes = useStyles();
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    // Handle left drawer
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const user = useSelector((state) => state.account.user);
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };
    React.useEffect(() => {
        if(!matchDownMd){
            dispatch({ type: SET_MENU, opened: !matchDownMd });
        } else {
            setTimeout(() => {
                dispatch({ type: SET_MENU, opened: !matchDownMd });
            }, 300)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);

    return (
        <div className={classes.root}>
            <CssBaseline />
            {/* header */}
            <AppBar
               // enableColorOnDark
                position="fixed"
                elevation={0}
                className={leftDrawerOpened ? `${classes.appBarWidth} no-print` : `${classes.appBar} no-print`}
            >   
                <Toolbar>
                    <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
                </Toolbar>
                {user != 'guest_user' && <FixedMenuLayout/>}
            </AppBar>

            {/* drawer */}
            {/* <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} /> */}

            {/* main content */}
            <main
                className={clsx([
                    classes.content,
                    {
                        [classes.contentShift]: leftDrawerOpened,
                        [classes.footer]: matchDownMd,
                        [classes.guest_footer]: user == 'guest_user'
                    }
                ])}
            >
                {/* <Main open={leftDrawerOpened}> */}
                {/* breadcrumb */}
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                <div>{children}</div>
                {/* </Main> */}
            </main>
        </div>
    );
};

MainLayout.propTypes = {
    children: PropTypes.node
};

export default MainLayout;
